import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the ActiveconfirmPage page.
 *
 * Generic dark confirm dialog reused for the Active apply / close prompts
 * (first-time and repeat variants share this same page, only the text differs).
 */

@IonicPage()
@Component({
    selector: 'page-activeconfirm',
    templateUrl: 'activeconfirm.html',
})
export class ActiveconfirmPage {

    message: string;
    confirmLabel: string;
    cancelLabel: string;
    language: string;

    constructor(
        public navParams: NavParams,
        public viewCtrl: ViewController
    ) {
        this.message = navParams.get('message');
        this.confirmLabel = navParams.get('confirmLabel');
        this.cancelLabel = navParams.get('cancelLabel');
    }

    ionViewWillEnter() {
        this.language = localStorage.getItem("language");
    }

    _cancel() {
        this.viewCtrl.dismiss(false);
    }

    _confirm() {
        this.viewCtrl.dismiss(true);
    }
}



// WEBPACK FOOTER //
// ./src/pages/activeconfirm/activeconfirm.ts